import { useEffect } from 'react';

import { useContentViewProgressMutation } from '../../graphql/mutations/generated/contentViewProgress';
import { Params } from './types';
import { getContentViewProgressMutationVariables } from './utils';

const useContentViewProgress = (params: Params) => {
  const {
    entityId,
    parentEntityId,
    resume,
    pause,
    isContentVisited = false,
    isSetView = true,
  } = params;
  const [, executeContentViewProgressMutation] = useContentViewProgressMutation();

  useEffect(() => {
    if (pause || (!isContentVisited && !isSetView)) {
      return;
    }

    const variables = getContentViewProgressMutationVariables({
      entityId,
      resume,
      isContentVisited,
      isSetView,
      parentEntityId,
    });

    executeContentViewProgressMutation(variables);
  }, [
    entityId,
    executeContentViewProgressMutation,
    pause,
    resume,
    isContentVisited,
    isSetView,
    parentEntityId,
  ]);
};

export default useContentViewProgress;
